import React from 'react';
import classNames from 'classnames';
import MapUnitPatterns from '../MapUnit/MapUnitPatterns';

const MapOverlayBaseRenderer = React.memo(({
  version, width, height, viewBox,
  tagless_defs_markup, tagless_style_markup, bg_markup,
  levelContent, unitShapesMarkup, placeShapesMarkup,
  onUnitClick,
  units, platformShowOccupancy, unitFill, unitStroke,
  isResidencesGuideActive = false,
  levelFading = false,
}) => (
  <svg
    className="svgMap"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    version={version || ''}
    width={width || 0}
    height={height || 0}
    viewBox={viewBox || '0 0 0 0'}
    overflow="visible"
  >
    <defs>
      {tagless_defs_markup && (
      <g dangerouslySetInnerHTML={{ __html: tagless_defs_markup }} />
      )}
      <MapUnitPatterns
        units={units}
        platformShowOccupancy={platformShowOccupancy}
        unitFill={unitFill}
        unitStroke={unitStroke}
      />
    </defs>
    {tagless_style_markup && (
    <style dangerouslySetInnerHTML={{ __html: tagless_style_markup }} />
    )}
    <g dangerouslySetInnerHTML={{ __html: bg_markup }} />
    <g className={classNames('svgMap__levelContent', {
      'svgMap__levelContent--fading': levelFading,
    })}
    >
      {levelContent}
      {unitShapesMarkup && (
      <g
        className={classNames('svgMap__unitShapes', {
          'svgMap__unitShapes--pulsing': isResidencesGuideActive,
        })}
        dangerouslySetInnerHTML={{ __html: unitShapesMarkup }}
        onClick={onUnitClick}
      />
      )}
      {placeShapesMarkup && (
      <g className="svgMap__placeShapes" dangerouslySetInnerHTML={{ __html: placeShapesMarkup }} />
      )}
    </g>
  </svg>
));

export default MapOverlayBaseRenderer;
